type ApiEnvName =
  | 'NEXT_PUBLIC_API_URL'
  | 'NEXT_PUBLIC_USER_API_URL'
  | 'NEXT_PUBLIC_API_GATEWAY_URL'
  | 'NEXT_PUBLIC_AUTH_URL'

const apiEnvValues: Record<ApiEnvName, string | undefined> = {
  NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
  NEXT_PUBLIC_USER_API_URL: process.env.NEXT_PUBLIC_USER_API_URL,
  NEXT_PUBLIC_API_GATEWAY_URL: process.env.NEXT_PUBLIC_API_GATEWAY_URL,
  NEXT_PUBLIC_AUTH_URL: process.env.NEXT_PUBLIC_AUTH_URL,
}

export function requireEnv(name: ApiEnvName) {
  const value = apiEnvValues[name]
  if (!value) {
    throw new Error(`${name} is not set in the environment variables`)
  }

  return value.replace(/\/+$/, '')
}

export const getApiUrl = () => {
  const apiUrl = requireEnv('NEXT_PUBLIC_API_URL')
  return `${apiUrl}/v1`
}

export const getApiV2Url = () => {
  const apiUrl = requireEnv('NEXT_PUBLIC_API_URL')
  return `${apiUrl}/v2`
}

export const getUserApiUrl = () => {
  const apiUrl = requireEnv('NEXT_PUBLIC_USER_API_URL')
  return `${apiUrl}/v1`
}

export const getUserApiV2Url = () => {
  const apiUrl = requireEnv('NEXT_PUBLIC_USER_API_URL')
  return `${apiUrl}/v2`
}

export const getPublicApiBaseV1 = () => getApiUrl()

export const getApiGatewayUrl = () => {
  return requireEnv('NEXT_PUBLIC_API_GATEWAY_URL')
}

export const getAuthUrl = () => {
  return requireEnv('NEXT_PUBLIC_AUTH_URL')
}
